import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { ColorPickerModule } from 'ngx-color-picker';
import { MaterialModule } from 'src/app/core/material.module';
import { AnnotationsService } from '../../../services/annotations.service';

@Component({

  selector: 'app-annotatio-type-main-info',
  templateUrl: './annotatio-type-main-info.component.html',
  styleUrls: ['./annotatio-type-main-info.component.scss'],
   imports: [
    ColorPickerModule,
      CommonModule,
      MaterialModule,
      ReactiveFormsModule,
    ]
})
export class AnnotatioTypeMainInfoComponent implements OnInit {
  @Output() mainInformation = new EventEmitter<any>();
  @Input() annotationData :any;

  color: string = '#555'
  textColor: string = '#000'
  public annotationForm = new FormGroup({
    color: new FormControl(this.color, [
      Validators.required,
    ]),
    textColor: new FormControl(this.textColor, [
      Validators.required,
    ]),
    opacity: new FormControl('0.5', [
      Validators.required,
    ]),
    eventType: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(256),

    ]),
    label: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(256),
    ]),
    hotKeys: new FormControl('')
  });

  constructor(public vcRef: ViewContainerRef,private annotationsService: AnnotationsService,) {
    this.annotationsService.eventEmitter.subscribe((d) => {
      if(d == 'sendData') {
        this.sendData();
      }
    })
   }

  ngOnInit(): void {
  }
  public onChangeColor(color: string): void {
    this.color = color;
    this.annotationForm.patchValue({ color });
  }

  public onChangeBackgroundColor(textColor: string): void {
    this.textColor = textColor;
    this.annotationForm.patchValue({ textColor });
  }

  ngOnChanges(){

    this.setFormValue();
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  sendData(){
    this.validateAllFormFields( this.annotationForm)
    if(this.annotationForm.valid)
    this.mainInformation.emit(this.annotationForm.value);
   else{
    this.mainInformation.emit(this.annotationForm.valid);
   }
  }
  setFormValue(){
    this.annotationForm.patchValue({
      color:this.annotationData.color,
      textColor:this.annotationData.textColor,
      opacity:this.annotationData.opacity,
      eventType: this.annotationData.eventType,
      label: this.annotationData.label,
    })
  }
}
